import { BASE_CONTEXT_V2_USER_FEEDBACK } from "./api-context";

export const USER_FEEDBACK = {
    CREATE:`${BASE_CONTEXT_V2_USER_FEEDBACK}create`,
}